<template>
    <div class="product-showcase-feature-wrapper section-space--pt_120 pb-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="section-title-wrapper section-space--mb_60 wow move-up">
                        <h3 class="font-weight--light text-primary">{{ sectionTitle }}</h3>
                    </div>
                </div>
                <div class="col-lg-8 wow move-up mtn-30">
                    <div v-for="(feature, index) in productFeature" :key="index" class="ht-product-service-box mt-30 px-3">
                        <div class="content-header">
                            <div class="icon">
                                <i :class="feature.icon"></i>
                            </div>
                            <h6 class="heading">{{ feature.title }}</h6>
                        </div>
                        <div class="content-body">
                            <div class="service_text" v-html="feature.desc "></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'ProductShowcase',
        data(){
            return {
                sectionTitle: 'Vantaggi del processo"',
                productFeature: [
                    {
                        icon: 'fal fa-user-minus',
                        title: 'Riduzione dei consumi',
                        desc: '• Minori consumi di acqua, elettricità e gas<br/>• Minor consumo di elettricità nella riattivazione<br/>• Riduzione del numero di colonne di riattivazione<br/>• Riduzione dei tempi di inattività<br/>• Minori manutenzioni',
                    },
                    {
                        icon: 'fal fa-calendar-minus',
                        title: 'Riduzione degli sprechi',
                        desc: '• Massiccia riduzione del personale necessario<br/>• Riduzione dei tempi di pulizia e dei detergenti impiegati<br/>• Controllo del peso delle porzioni<br/>• Minori sprechi di materie prime in produzione<br/>• Riduzione della perdita di peso in cottura delle materie prime',
                    },
                ]
            }
        }
    };
</script>